/**
 * NOTICE: use only IDs as targets, don't use document.querySelector
 * as it is computed when html is not yet present and results in broken tours
 */

const tours = [
  {
    id: 'home',
    steps: [
      {
        title: 'Main menu',
        content: `Click on the 3-lines button to show the main menu,
from here you can access all the features`,
        target: 'main-nav-icon',
        placement: 'right',
        nextOnTargetClick: true,
        showNextButton: false
      },
      {
        title: 'User info',
        content: `Here you can see your info and the Organization you are currently in.
Click anywhere to close the menu.`,
        target: 'user-menu',
        placement: 'right',
        yOffset: 20,
        zindex: 10
      },
      {
        title: 'Organizations',
        content: `An organization in atlas is a container for projects, members, settings, etc.
Everyone has at least 1 organization and everything happens inside the organization itself.`,
        target: 'main-content',
        placement: 'top',
        xOffset: 'center',
        yOffset: 230,
        arrowOffset: 'center'
      },
      {
        title: 'Dashboard',
        content: `The dashboard shows statistics about your organization:
projects count and status, upcoming milestones, events, members, etc.`,
        target: 'main-content',
        placement: 'top',
        xOffset: 'center',
        yOffset: 230,
        arrowOffset: 'center'
      },
      {
        title: 'Tools',
        content: `This icon is always present on the bottom right and gives you access
to useful tools. Click the tools icon.`,
        target: 'global-tools',
        placement: 'left',
        nextOnTargetClick: true,
        showNextButton: false,
        yOffset: -71,
        arrowOffset: 60,
        zindex: 6
      },
      {
        title: 'Help Tool',
        content: `At the moment there are the Help tool and the Recent Files list.
Hover the mouse on the icons to see their names and click on the Help tool.`,
        target: 'global-tools-help',
        placement: 'left',
        nextOnTargetClick: true,
        showNextButton: false,
        zindex: 6
      },
      {
        title: 'Help',
        content: `The help tool shows the user guide relative to the current page and
(when available) also a guided tour like the one your following now.`,
        target: 'help-menu',
        placement: 'left',
        yOffset: 20
      }
    ]
  },
  {
    id: 'project-activities',
    steps: [
      {
        title: 'Create new Activity',
        content: 'Click on the + button',
        target: 'project-activities__add-btn',
        placement: 'left'
      }
    ]
  }
]

export function getTourById (id) {
  return tours.find(tour => tour.id === id)
}
